import { OPEN_GALLERY, CLOSE_GALLERY } from 'context/constants';

export const openGallery = image => ({
  type: OPEN_GALLERY,
  payload: image
});

export const closeGallery = () => ({
  type: CLOSE_GALLERY
});
